import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/wnba.jpg?w=1920&ch=width&auto=format,compress"
        title="Watch WNBA with Fubo"
        subtitle="Catch the action live all season long"
        networkSet="womensBasketball"
        league="WNBA"
        showRSN={true}
        sportId={sportIds.Basketball}
        leagueId={leagueIds.WNBA}
        matchtickerSportId={sportIds.Basketball}
        matchtickerLeagueName="WNBA"
        matchtickerLeagueId={leagueIds.WNBA}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .videoWrapper {
    @media (max-width: 768px) {
      background-position: 60% center;
    }
  }
`
